<template>
    <div class="dbQueries">
        <LogManage @log="handleLog"/>
        <transition name="successMessage" tag = "div" appear>
        <div v-if="loggedUser">
            <h2>Database Management</h2>
            <button @click="selectedDB = 'sdf1'" :class="{selecteddb: selectedDB === 'sdf1'}">SDF-1</button>
            <button @click="selectedDB = 'sdf3'" :class="{selecteddb: selectedDB === 'sdf3'}">SDF-3</button>
            <form>
                <h3 for="">Add docs:</h3>
                <h4>Category Name:</h4>
                <input type="text" v-model="category" required>
                <h4>Intro:</h4>
                <textarea type="text" v-model="intro"></textarea>
                <h4>Add answer:</h4>
                <textarea v-for="(answer, index) in answers" type="text" v-model="answers[index]">your answer...</textarea>

                <div class="addanswer">click to add new answer...</div>
                <div><span @click="newAnswer" class="material-symbols-outlined">add</span></div>
                <button @click="handleSubmit">Submit</button>
            </form>
            <transition name="successMessage">
                <div class="successMessageClass" v-if="successMessage">
                    {{successMessage}}
                </div>
            </transition>
            <transition-group name="answerGroup" class="tg" tag="div" appear>
            <div v-for="(category, index) in categories" class="category db" :key="index">
                <div class="iconsWrapper">
                    <span @click="handleDeleteDoc(category.id)" class="material-symbols-outlined">delete</span>
                    <span @click="openEditMode(category, index, category.answers.length, category.answers)" class="material-symbols-outlined">edit</span>
                </div>
                
                <h5>{{category.category}}</h5>
                <h5 v-if="openEditsTable[index]">
                    <input type="text" placeholder="new category name" v-model="editedCategory">    
                </h5>
                <h4 v-html = "category.intro" class="intro"></h4>
                <textarea v-if="openEditsTable[index]" type="text" v-model="editedIntro"></textarea>
                <p v-for="(answer, jindex) in category.answers" class="answer">
                    <span v-html = "answer"></span>
                    <span @click="handleDeleteAnswer(category.category, category.id, jindex, category.answers)" class="material-symbols-outlined small">delete</span>
                    <textarea v-if="openEditsTable[index]" type="text" placeholder="new answer" v-model="editedAnswers[jindex]"></textarea>
                </p>

                <div v-if="openEditsTable[index]">
                    <span @click="newAnswerEdit(category.id, category.category, index)" class="material-symbols-outlined">add</span></div>
                <button v-if="openEditsTable[index]" @click="handleSubmitEdits(category.id, category.answers.length, category.answers)">Submit edits</button>
                <p><b v-if="category.createdAt">CreatedAt: {{String(toDateTime(category.createdAt.seconds)).substring(4, 24)}}</b></p>
            </div>
        </transition-group>
        </div>
        </transition>
        
    </div>
</template>


<script>
import LogManage from '../components/LogManage.vue'
import {ref, watchEffect } from 'vue'
import { db, colRefSdf1, doc, addDoc, deleteDoc, serverTimestamp, updateDoc} from '../main.js'
import { onMounted } from 'vue'
import getDataFirebase from '../composables/getDataFirebase'
    export default {
        name: 'DbQueries',
        components: {LogManage},
        
        setup(){
            onMounted(()=>{
                document.querySelector('body').style.overflow = 'scroll'
            })
            const loggedUser = ref(false)
            const logModal = ref(false)
            const selectedDB = ref('sdf1')
            const category = ref('')
            //const categories = ref([])
            const answers = ref([''])
            const intro = ref('')
            const successMessage = ref('')
            const dbChange = ref(false)

            const showEditWindow = ref(false)
            const editedCategory = ref('')
            const editedIntro= ref('')
            const editedAnswers = ref([])
            const newEditedAnswer = ref('')
            const { categories, openEditsTable, errorMessage, load, addDocsToDb, deleteDocFromDb, deleteAnswerFromDb, submitEditsToDb, addNewAnswerToDb } = getDataFirebase()
            

            watchEffect(()=>{
                load(selectedDB.value)
            })
            const handleSubmit = (e) => {
                e.preventDefault()
                addDocsToDb(category, answers, intro)
                    .then(()=>{
                        category.value = ""
                        intro.value = ""
                        answers.value = ['']
                        successMessage.value = 'Item successfully added to the database'
                        setTimeout(()=>{
                            successMessage.value = ''
                        }, 4000)
                    })
                    .catch((err)=>{
                        console.log(err.message)
                    })
            }    
            const newAnswer = () =>{
                answers.value.push('')
            }
            const handleDeleteDoc = (id) => {
                if(confirm('Are you sure that you want to delete this category?')){
                    deleteDocFromDb(id)
                }            
            }
            const handleDeleteAnswer = (category, id, jindex, answers) => {
                if(confirm('Are you sure that you want to delete this answer?')){
                    deleteAnswerFromDb(category, id, jindex, answers)
                }
                
            }
            function toDateTime(secs) {
                var t = new Date(1970, 0, 1, 1); // Epoch
                t.setSeconds(secs);
                return t
            }
            const openEditMode = (category, i, leng, answers) => {

                openEditsTable.value[i] = !openEditsTable.value[i]
                editedAnswers.value = []
                editedCategory.value = category.category
                editedIntro.value = category.intro
                for(let i = 0; i < leng; i++){
                    editedAnswers.value.push(answers[i])
                }
            }
            const handleSubmitEdits = (id) => {
                submitEditsToDb(id, editedCategory, editedAnswers, editedIntro)
                
            }
            const newAnswerEdit = (id, category, i) => {
                addNewAnswerToDb(id, category, i, editedAnswers)
                    .then(() => {
                        openEditsTable.value[i] = true
                })
            }
            const handleLog = (user) => {
                loggedUser.value = user 
            }
            return {
                handleSubmit, category, newAnswer, answers, successMessage, categories, handleDeleteDoc, handleSubmitEdits, showEditWindow, editedCategory, openEditsTable, editedAnswers, openEditMode, newAnswerEdit, newEditedAnswer, handleDeleteAnswer, toDateTime, selectedDB, logModal, handleLog, loggedUser, intro, editedIntro
            }
        }
    }
</script>

<style>
    h3{
        margin-bottom: 2.5em;
        margin-top: 2.5em;
    }
    h4{
        margin-bottom: 0.7em;
        margin-top: 2em;
    }
    input, textarea{
        display: block;
        padding: 0.5em;
        margin-bottom: 0.5em;
        margin: 0.5em auto;
        border-radius: 0.5em;
        outline: none;
    }
    textarea{
        min-height: 12em;
        min-width: 90%;
    }
    button{
        font-weight: 700;
        display: inline-block;
        padding: 0.9em;
        margin-top: 1.2em;
        margin-bottom: 0.5em;
        border: none;
        outline: none;
        transition: all 0.3s ease;
        -webkit-box-shadow: 8px 8px 14px 0px rgba(66, 68, 90, 1);
        -moz-box-shadow: 8px 8px 14px 0px rgba(66, 68, 90, 1);
        box-shadow: 8px 8px 14px 0px rgba(66, 68, 90, 1);
    }
    button:hover{
        background-color: rgb(255, 255, 255);
        cursor: pointer;
        transform: scale(1.1);
    }
    .addanswer{
        margin-top: 2em;
    }
    /* transitions */
    .successMessage-enter-from, .successMessage-leave-to{
        opacity: 0;
    }
    .successMessage-enter-active, .successMessage-leave-active{
        transition: opacity 1.9s ease;
    }
    .successMessageClass{
        color: forestgreen;
    }
    .dbdata{
        margin-top: 1.5em;
    }
    .dbdata h5{
        margin-top: 0.2em;
    }
    .small{
        font-size: 1em;
    }
    .category .answersContainer{
        border-bottom: 0.5px dashed rgb(112, 109, 109);
    }
    .category .answersContainer:last-child{
        border-bottom: none;
    }
    .category .answer:hover{
        cursor: pointer;
        text-shadow: 2px 2px 10px rgb(166, 167, 175);
        /* background-color: rgba(173, 216, 230, 0.15); */
    }
    /* .category .answersContainer:first-child{
        border-top: 0.5px dashed rgb(112, 109, 109);;
    } */

    .iconsWrapper{
        text-align: right;
        height: 0;
    }
   
    .dbQueries .selecteddb{
        transform: scale(1.1);
        cursor: default;
        background-color: lightblue;
    }
    .login{
        position: relative;
        top: -7px;
    }
    .category.db{
        max-height: 300em;
        transform: scale(1.0);
        cursor: default;
    }
    .category > .intro{
        border-bottom: solid grey 1px;
        padding-bottom: 1em;
    }
    .category.db > .answer {
        border-bottom: dashed grey 1px;
    }
</style>
  